module.exports = __webpack_public_path__ + "static/media/LogoBlue@3x.ec10b39a.ec10b39a.png";